import { render, staticRenderFns } from "./TerrenoProgrmas.vue?vue&type=template&id=170eabeb&scoped=true&lang=html&"
import script from "./TerrenoProgrmas.vue?vue&type=script&lang=js&"
export * from "./TerrenoProgrmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170eabeb",
  null
  
)

export default component.exports